const PaymentTypeEnum = {
  NICE: 1,
  LINE: 2,
  SOFTBANK: 3,
  KOVAN: 4,
  HECTO: 6,
  COAM: 8,
  SMARTRO: 9,
  KSNET: 10,
  CALLGATE: 11,
  PAYSTORY: 12,
};

export default PaymentTypeEnum;
